import type { VisitorCollection } from '../types';

export function validateVisitors(_visitors: VisitorCollection): boolean {
	return true;
}
